import React from "react";
import ReactSelect from "react-select";

import Label from "components/shared/form/Label";
import { Control, Controller } from "react-hook-form";
import Hint from "components/shared/fields/Hint";
import classNames from "classnames";
import { get, isString, map } from "lodash";

export function extractValues(values: any[] | any, key = "value"): string[] {
  return map(values, (v) => (isString(v) ? v : v?.[key]));
}

export function extractFirstValue(values: any[] | any, key = "value"): string {
  return extractValues(values, key)?.[0];
}

type SelectArgs = {
  name: string;
  label?: string;
  multi?: boolean;
  required?: boolean | string;
  control?: Control<any>;
  options: {
    key?: string | number;
    value: any;
    label: string | React.ReactElement;
  }[];
  placeholder?: string;
  isSearchable?: boolean;
  hint?: string;
  isLoading?: boolean;
  error?: boolean;
  disabled?: boolean;
};
export default function Select({
  label,
  name,
  multi = false,
  required = false,
  options,
  control,
  placeholder,
  isSearchable = true,
  hint,
  isLoading = false,
  error = false,
  disabled = false,
}: SelectArgs) {
  return (
    <div className="control-group">
      {label && <Label label={label} required={!!required} />}
      <div className="controls remove-input-txt-border">
        <Controller
          name={name}
          control={control}
          rules={{ required: required }}
          render={({ field, formState }) => (
            <>
              <ReactSelect
                closeMenuOnSelect
                isMulti={multi}
                options={options}
                placeholder={placeholder}
                isSearchable={isSearchable}
                noOptionsMessage={() => I18n.t("js.plugins.select2.no_match")}
                {...field}
                className={classNames("form-select-container", {
                  "field-error": !!get(formState.errors, name) || error,
                })}
                classNamePrefix="form-select"
                isLoading={isLoading}
                isDisabled={disabled}
                unstyled
              />
              {hint && <Hint hint={hint} />}
            </>
          )}
        />
      </div>
    </div>
  );
}
